var React = require('react');
const { useTranslation } = require('react-i18next');
const { useState } = require('react');
const { getCropTypePrefix } = require('./CropManagement.util');
var cropDataManager = require('cropDataManager');
var CSS = require('../crop/CropManagement.scss');
var { upper } = require('@managers/helpers');

const AddNewCropSection = ({ crops, onUpdate, showToast }) => {
  const [newCropType, setNewCropType] = useState('');
  const [newCropVariety, setNewCropVariety] = useState('');
  const [newSubCropVariety, setNewSubCropVariety] = useState('');
  const [newCropFeature, setNewCropFeature] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { t } = useTranslation();

  const handleNewCropTypeChange = (crop) => {
    setNewCropVariety('general');
    crop = crop.toLowerCase();
    setNewCropType(crop);
    setNewCropFeature('general');
  };

  const handleNewCropVarietyChange = (variety) => {
    setNewCropFeature('general');
    setNewCropVariety(variety.toLowerCase());
  };

  function handleNewSubCropVarietyChange(subVariety) {
    setNewCropFeature('general');
    setNewSubCropVariety(subVariety.toLowerCase());
  }

  const handleNewCropFeatureChange = (feature) => {
    setNewCropFeature(feature.toLowerCase());
  };

  const handleAddNew = () => {
    let crop_type = '';
    if (
      newCropType &&
      newCropVariety &&
      newCropVariety !== 'general' &&
      newCropFeature &&
      newCropFeature !== 'general'
    ) {
      if (newSubCropVariety && newSubCropVariety !== 'general') {
        crop_type = getCropTypePrefix(
          crops,
          newCropType,
          newCropVariety,
          newCropFeature,
        );
        if (crop_type !== '') {
          crop_type =
            crop_type + '#' + newSubCropVariety + '$' + newCropFeature;
        } else {
          crop_type =
            newCropType +
            '#' +
            newCropVariety +
            '#' +
            newSubCropVariety +
            '$' +
            newCropFeature;
        }
      } else {
        crop_type = getCropTypePrefix(
          crops,
          newCropType,
          newCropVariety,
          newCropFeature,
        );
        if (crop_type !== '') {
          crop_type = crop_type + '$' + newCropFeature;
        } else {
          crop_type = newCropType + '#' + newCropVariety + '$' + newCropFeature;
        }
      }
    } else if (
      newCropType &&
      newCropVariety &&
      newCropVariety !== 'general' &&
      (newCropFeature === '' || newCropFeature === 'general')
    ) {
      if (newSubCropVariety && newSubCropVariety !== 'general') {
        crop_type = getCropTypePrefix(crops, newCropType, newCropVariety);
        if (crop_type !== '') {
          crop_type = crop_type + '#' + newSubCropVariety;
        } else {
          crop_type =
            newCropType + '#' + newCropVariety + '#' + newSubCropVariety;
        }
      } else {
        crop_type = newCropType + '#' + newCropVariety;
      }
    } else if (
      newCropType &&
      (newCropVariety === 'general' || newCropVariety === '') &&
      newCropFeature &&
      newCropFeature !== 'general'
    ) {
      crop_type = newCropType + '$' + newCropFeature;
    } else if (
      newCropType &&
      (newCropVariety === 'general' || newCropVariety === '') &&
      (newCropFeature === 'general' || newCropFeature === '')
    ) {
      crop_type = newCropType;
    }

    if (
      newCropType in crops &&
      newCropVariety in crops[newCropType] &&
      newSubCropVariety in crops[newCropType] &&
      (newCropFeature in crops[newCropType][newCropVariety] ||
        newCropFeature in crops[newCropType][newSubCropVariety])
    ) {
      showToast('error', t('crop_key_already_exists'));
      return;
    }
    crop_type = crop_type.toLowerCase();

    try {
      cropDataManager
        .addNewCropItem({
          crop_type: crop_type,
          gdd: {},
          yield: {},
        })
        .then((res) => {
          if (res['success']) {
            onUpdate();
            showToast('success', t('crop_added_successfully'));
          }
        })
        .catch((err) => {
          console.error('Error adding crop item:', err);
          showToast('error', t('crop_add_failed'));
        });
      if (typeof mixpanel !== 'undefined') {
        mixpanel.track('Crop Added', {
          'Crop ID': crop_type,
          'Crop Name': newCropType,
        });
      }
    } catch (error) {
      console.error('Error adding crop item:', error);
      showToast('error', t('crop_add_failed'));
    }
  };

  return (
    <div className='crop-section-card'>
      <div
        className='crop-section-header'
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h2>
          <svg
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#4563c7'
            strokeWidth='2'
          >
            <circle cx='12' cy='12' r='10' />
            <line x1='12' y1='8' x2='12' y2='16' />
            <line x1='8' y1='12' x2='16' y2='12' />
          </svg>
          {t('add_new_crop') || 'Add New Crop'}
        </h2>
        <span className={`collapse-icon ${isCollapsed ? 'collapsed' : ''}`}>
          ▼
        </span>
      </div>

      {!isCollapsed && (
        <div className='crop-section-content'>
          <div className='form-row-group'>
            <div className='form-field'>
              <label>{t('crop_type')}</label>
              <input
                list='crop-type-list'
                placeholder={
                  t('select_or_enter_crop_type') || 'Select or enter crop type'
                }
                onChange={(e) => handleNewCropTypeChange(e.target.value)}
              />
              <datalist id='crop-type-list'>
                {crops &&
                  Object.keys(crops)
                    .sort()
                    .map((item) => <option key={item} value={item} />)}
              </datalist>
            </div>

            <div className='form-field'>
              <label>{t('kc_variety')}</label>
              <input
                list='crop-variety-list'
                placeholder={
                  t('select_or_enter_variety') || 'Select or enter variety'
                }
                onChange={(e) => handleNewCropVarietyChange(e.target.value)}
              />
              <datalist id='crop-variety-list'>
                {crops &&
                  newCropType in crops &&
                  Object.keys(crops[newCropType])
                    .sort()
                    .map((item) => <option key={item} value={item} />)}
              </datalist>
            </div>

            <div className='form-field'>
              <label>{'Sub ' + t('kc_variety')}</label>
              <input
                type='text'
                placeholder={
                  t('enter_sub_variety') || 'Enter sub variety (optional)'
                }
                onChange={(e) => handleNewSubCropVarietyChange(e.target.value)}
              />
            </div>

            <div className='form-field'>
              <label>{t('kc_feature')}</label>
              <input
                list='crop-feature-list'
                placeholder={
                  t('select_or_enter_feature') || 'Select or enter feature'
                }
                onChange={(e) => handleNewCropFeatureChange(e.target.value)}
              />
              <datalist id='crop-feature-list'>
                {crops &&
                  newCropType in crops &&
                  newCropVariety in crops[newCropType] &&
                  Object.keys(crops[newCropType][newCropVariety])
                    .sort()
                    .map((item) => (
                      <option key={item} value={item}>
                        {t(upper(item))}
                      </option>
                    ))}
              </datalist>
            </div>
          </div>

          <div className='action-buttons'>
            <button className='btn-primary-crop' onClick={handleAddNew}>
              {t('add_new_button') || 'Add New'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

module.exports = AddNewCropSection;
